import React from "react";
import NewsCard from "../../template/NewsCard";

import "./News.css";

export default ({ data }) => {
  const featuredNews = data.slice(0, 2);

  return (
    <div className="our-performance">
      <h1>NOTÍCIAS</h1>

      {featuredNews.map((featuredNew) => (
        <NewsCard
          key={featuredNew.id}
          img={featuredNew.image_url}
          date={featuredNew.date}
          author={featuredNew.author}
          title={featuredNew.title}
          subtitle={featuredNew.description}
          path={`/nossa-atuacao/noticias/${featuredNew.slug}`}
        />
      ))}
    </div>
  );
};
